import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const operationAdminService = createApi({
    reducerPath: 'operationAdminService',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getOperationTickets: builder.query({
            query: ({ search, page, limit }) => ({
                url: '/jobs/v1/support-member-tickets',
                method: 'GET',
                params: {
                    page,
                    search,
                    limit
                },
            }),
        }),
    }),
});

export const { useGetOperationTicketsQuery } = operationAdminService;
